"use strict";
var React = require('react')
var Link = require('react-router')
var LanguageStore = require('../../store/LanguageStore')
var DocMeta = require('react-doc-meta');

var SertifikatiOkvalitetu = React.createClass({
  componentDidMount() {
      LanguageStore.addChangeListener(this.onChange);
    },
    getInitialState() {
        var state = LanguageStore.getLanguage();
        return state;
    },
    onChange() {
        var state = LanguageStore.getLanguage();
        this.setState(state);
    },
    componentWillUnmount() {
        LanguageStore.removeChangeListener(this.onChange);
    },
  render() {
    return(this.state.lang === 'uk' ? this.ContentEng() : this.state.lang === 'de' ? this.ContentGer() : this.state.lang === 'rs' ? this.ContentSrb() : null)
  },
  ContentSrb(){
    document.title = 'Sertifikati o kvalitetu | Termovent SC Livnica čelika A.D. Bačka Topola'
      var tags = [
      {name: "description", content: "Sertifikati o kvalitetu Termovent SC Livnice čelika A.D. iz Bačke Topole"},
      {name: "keyword", content: "sertifikat,kvalitet,iso,ISO 9001:2008,OHSAS 18001:2007,ISO 14001:2004,AD 2000"},
      {itemProp: "name", content: "Sertifikati o kvalitetu | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {itemProp: "description", content: "Sertifikati o kvalitetu Termovent SC Livnice čelika A.D. iz Bačke Topole"},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:title", content: "Sertifikati o kvalitetu | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:description", content: "Sertifikati o kvalitetu Termovent SC Livnice čelika A.D. iz Bačke Topole"},
      {name: "twitter:creator", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Sertifikati o kvalitetu | Termovent SC Livnica čelika A.D. Bačka Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Sertifikati o kvalitetu Termovent SC Livnice čelika A.D. iz Bačke Topole"},
      {property: "og:site_name", content: "Termovent SC Livnica čelika A.D. Bačka Topola"},
    ]
    return (<DocMeta tags={tags}>
            <div className='container'>
        <div className='index-content row'>
        <h1 className='onamaHeading text-center'>SERTIFIKATI O KVALITETU</h1>
          <br/><br/>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='img/sertifikati/00000.jpg' alt='ISO 9001:2008'/></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='img/sertifikati/00011.jpg' alt='OHSAS 18001:2007'/></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='img/sertifikati/00022.jpg' alt='ISO 14001:2004' /></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='img/sertifikati/00033.jpg' alt='AD 2000' /></div>
            <div className='col-md-2'></div>
          </div>
        </div>
      </div>
      </DocMeta>
    )
  },
  ContentEng(){
    document.title = 'QUALITY CERTIFICATES | Termovent SC Steal foundry J.S.C Backa Topola'
      var tags = [
      {name: "description", content: "Certificates of Termovent SC Steal foundry J.S.C Backa Topola, Serbia"},
      {name: "keyword", content: "ISO 9001:2008,OHSAS 18001:2007,ISO 14001:2004,AD 2000,certificates,quality"},
      {itemProp: "name", content: "QUALITY CERTIFICATES | Termovent SC Steal foundry J.S.C Backa Topola"},
      {itemProp: "description", content: "Certificates of Termovent SC Steal foundry J.S.C Backa Topola, Serbia"},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:title", content: "QUALITY CERTIFICATES | Termovent SC Steal foundry J.S.C Backa Topola"},
      {name: "twitter:description", content: "Certificates of Termovent SC Steal foundry J.S.C Backa Topola, Serbia"},
      {name: "twitter:creator", content: "Termovent SC Steel foundry"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "QUALITY CERTIFICATES | Termovent SC Steal foundry J.S.C Backa Topola"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Certificates of Termovent SC Steal foundry J.S.C Backa Topola, Serbia"},
      {property: "og:site_name", content: "Termovent SC Steel foundry J.S.C"},
    ]
    return (<DocMeta tags={tags}>
            <div className='container'>
        <div className='index-content row'>
        <h1 className='onamaHeading text-center'>QUALITY CERTIFICATES</h1>
          <br/><br/>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='../img/sertifikati/00000.jpg' alt='ISO 9001:2008' /></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='../img/sertifikati/00011.jpg' alt='OHSAS 18001:2007' /></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='../img/sertifikati/00022.jpg' alt='ISO 14001:2004' /></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='../img/sertifikati/00033.jpg' alt='AD 2000'  /></div>
            <div className='col-md-2'></div>
          </div>
        </div>
      </div>
      </DocMeta>
    )
  },
  ContentGer(){
    document.title = 'Zertifikate | Die Termovent SC Stahlfabrik GmbH'
      var tags = [
      {name: "description", content: "Zertifikat Stahlgießerei von Backa Topola"},
      {name: "keyword", content: "Termovent SC,Stahlfabrik,Stahlgusse,Serbien,iso,ISO 9001:2008,OHSAS 18001:2007,ISO 14001:2004,AD 2000"},
      {itemProp: "name", content: "Zertifikate | Die Termovent SC Stahlfabrik GmbH"},
      {itemProp: "description", content: "Zertifikat Stahlgießerei von Backa Topola"},
      {itemProp: "image", content: "http://www.livnica.com/css/company_logo.png"},
      {name: "twitter:card", content: "product"},
      {name: "twitter:site", content: "@publisher_handle"},
      {name: "twitter:title", content: "Zertifikate | Die Termovent SC Stahlfabrik GmbH"},
      {name: "twitter:description", content: "Zertifikat Stahlgießerei von Backa Topola"},
      {name: "twitter:creator", content: "Termovent SC Stahlfabrik GmbH"},
      {name: "twitter:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:type", content: "website"},
      {property: "og:title", content: "Zertifikate | Die Termovent SC Stahlfabrik GmbH"},
      {property: "og:url", content: "http://www.livnica.com/"},
      {property: "og:image", content: "http://www.livnica.com/css/company_logo.png"},
      {property: "og:description", content: "Zertifikat Stahlgießerei von Backa Topola"},
      {property: "og:site_name", content: "Die Termovent SC Stahlfabrik GmbH"},
    ]
    return (<DocMeta tags={tags}>
            <div className='container'>
        <div className='index-content row'>
        <h1 className='onamaHeading text-center'>ZERTIFIKATE</h1>
          <br/><br/>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='../img/sertifikati/00000.jpg' alt='ISO 9001:2008' /></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='../img/sertifikati/00011.jpg' alt='OHSAS 18001:2007' /></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='../img/sertifikati/00022.jpg' alt='ISO 14001:2004' /></div>
            <div className='col-md-2'></div>
          </div>
          <div className='row'>
            <div className='col-md-2'></div>
            <div className='col-md-8'><img className='onamaPic' src='../img/sertifikati/00033.jpg' alt='AD 2000'  /></div>
            <div className='col-md-2'></div>
          </div>
        </div>
      </div>
      </DocMeta>
    )
  }
})

module.exports = SertifikatiOkvalitetu;



/** WEBPACK FOOTER **
 ** ./modules/components/SertifikatiOkvalitetu/SertifikatiOkvalitetu.js
 **/